import CustomerProfileNav from "./CustomerProfileNav";

export default function CustomerProfileContent({ data }) {
  return (
    <div className="card border-0">
      <div className="card-body">
        <CustomerProfileNav data={data} />
      </div>
    </div>
  );
}
